import type { Ref } from 'vue'
export type BaseItem = { id: number }

interface BaseStoreType<T extends BaseItem> {
  selectedItems: Ref<T[]>
  items: Ref<T[]>
  openDeleteDialog: () => void
}

export const useSelectedItemMixin = <T extends BaseItem>(baseStore: BaseStoreType<T>) => {
  const updateSelectedItems = (checkBoxValue: boolean, filteredItems: T[]) => {
    if (checkBoxValue) {
      filteredItems.forEach((item) => {
        if (!baseStore.selectedItems.value.includes(item)) {
          baseStore.selectedItems.value.push(item)
        }
      })
    } else {
      filteredItems.forEach((item) => {
        const index = baseStore.selectedItems.value.findIndex(
          (selectedItem: T) => selectedItem.id === item.id
        )
        if (index !== -1) {
          baseStore.selectedItems.value.splice(index, 1)
        }
      })
    }
  }

  const clearSelectedItems = () => {
    if (baseStore.items.value) {
      baseStore.selectedItems.value = baseStore.selectedItems.value.filter((item: T) =>
        baseStore.items.value.includes(item)
      )
    } else {
      baseStore.selectedItems.value = []
    }
  }

  const deleteSelectedItems = () => {
    baseStore.openDeleteDialog()
  }

  return {
    updateSelectedItems,
    deleteSelectedItems,
    clearSelectedItems
  }
}
